import { getLocalStorage, safeGetStorageItem } from './browserStorage';

const ACCOUNT_ID_KEY = 'account_id';
const CSRF_META_SELECTOR = 'meta[name="csrf-token"]';
const EDITOR_SANITIZE_ALLOWED_TAGS = [
  'p',
  'br',
  'b',
  'i',
  'em',
  'strong',
  'a',
  'ul',
  'ol',
  'li',
  'img',
];
const EDITOR_SANITIZE_ALLOWED_ATTRS = ['href', 'src', 'alt', 'style', 'target'];

const getDefaultDocument = () =>
  typeof document !== 'undefined' ? document : null;

const getStoredEditorAccountId = (storage = getLocalStorage()) =>
  safeGetStorageItem(storage, ACCOUNT_ID_KEY);

const getEditorCsrfToken = (documentObject = getDefaultDocument()) => {
  try {
    return documentObject?.querySelector?.(CSRF_META_SELECTOR)?.content;
  } catch {
    return undefined;
  }
};

const buildEditorJsonHeaders = ({ authHeaders = {}, documentObject } = {}) => ({
  ...(authHeaders || {}),
  'Content-Type': 'application/json',
  'X-CSRF-Token': getEditorCsrfToken(documentObject),
});

const buildEditorVariableToken = (variable = '') => `{{${variable}}}`;

const getEditorVariableSearchTerm = (text = '') =>
  String(text || '').replace('{{', '');

const isEditorBodyEmpty = ({
  content = '',
  removeSignatureFn = (value) => value,
  signature = '',
} = {}) => {
  if (!content) return true;

  const bodyWithoutSignature =
    signature && typeof removeSignatureFn === 'function'
      ? removeSignatureFn(content, signature)
      : content;

  return bodyWithoutSignature.trim().length === 0;
};

const shouldPreventEditorLineBreak = ({
  hotKeyEnabled = false,
  overrideLineBreaks = false,
  pressed = false,
} = {}) => pressed && hotKeyEnabled && !overrideLineBreaks;

const buildEditorSanitizeOptions = () => ({
  ALLOWED_TAGS: [...EDITOR_SANITIZE_ALLOWED_TAGS],
  ALLOWED_ATTR: [...EDITOR_SANITIZE_ALLOWED_ATTRS],
});

export {
  buildEditorJsonHeaders,
  buildEditorSanitizeOptions,
  buildEditorVariableToken,
  getEditorCsrfToken,
  getEditorVariableSearchTerm,
  getStoredEditorAccountId,
  isEditorBodyEmpty,
  shouldPreventEditorLineBreak,
};
